import React, { useEffect, useState, useMemo } from "react";
import Navbar from "../../Navbar";
import { logEventos } from "../../../services/services";
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  Tooltip,
  MenuItem,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EvStationIcon from "@mui/icons-material/EvStation";
import { Delete } from "@mui/icons-material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Divider from "@mui/material/Divider";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
  MRT_ToggleFiltersButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleDensePaddingButton,
} from "material-react-table";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { getData, putData } from "../../../services/library";
import BajaClienteEnv from "./baja/BajaClienteEnv";
import TabAltaEnv from "./alta/TabAltaEnv";
import EdicionEnvasado from "./modificacion/EdicionEnvasado";
import FichaCliEnv from "./fichaCliente/FichaCliEnv";
import MarcarActivo from "./alta/MarcarActivo";
import { UrlApi } from "../../../services/apirest";
import BuscadorClientes from "./buscadorClientes/BuscadorClientes";

function ClientesEnvasado() {
  const [clientes, setClientes] = useState(); //aca se almacenan los datos que me trae la api
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los clientes
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [ficha, setFicha] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [baja, setBaja] = useState(false); //Abre formulario
  const [dataCliente, setDataCliente] = useState({});
  const [marcarActivo, setMarcarActivo] = useState(false);
  const [actualiza, setActualiza] = useState(1)
  //Tabla
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  const [loading, setLoading] = useState(false);
  const [filteredClientes, setFilteredClientes] = useState([]);
  // const obtenerclientesInactivos = () => {
  //   setHiddenmuestrainactivo(true);
  //   setHiddenmuestraactivos(false);
  //   getData("/envasado_clientes/sucauth/"+localStorage.getItem("suc_auth").split(","), setClientes);
  // };

  // //Funcion para traer los clientes a la tabla TODOS :ACTIVOS E INACTIVOS
  // const obtenerclientes = () => {
  //   setHiddenmuestraactivos(true);
  //   setHiddenmuestrainactivo(false);
  //   getData("/envasado_clientes/activossucauth/"+localStorage.getItem("suc_auth").split(","), setClientes);
  // };
  useEffect(() => {
  if (clientes) {
    setFilteredClientes(clientes);
  }
}, [clientes]);

  const obtenerclientes = async () => {
    setLoading(true);
    setHiddenmuestrainactivo(false);
    setHiddenmuestraactivos(true);
    try {
      const res = await fetch(`${UrlApi}/envasado_clientes/activossucauth/${localStorage.getItem("suc_auth").split(",")}`);
      const data = await res.json();
      setClientes(data);
    } catch (err) {
      console.error("Error al obtener clientes:", err);
      setClientes([]);
    } finally {
      setActualiza(0)
      setLoading(false);
    }
  };

  // 🔴 Función para obtener clientes (INACTIVOS)
  const obtenerclientesInactivos = async () => {
    setLoading(true);
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    try {
      const res = await fetch(`${UrlApi}/envasado_clientes/sucauth/${localStorage.getItem("suc_auth").split(",")}`);
      const data = await res.json();
      setClientes(data);
    } catch (err) {
      console.error("Error al obtener clientes inactivos:", err);
      setClientes([]);
    } finally {
      
      setLoading(false);
    }
  };
  
  useEffect(() => {
    if (actualiza === 1) {
      obtenerclientes();
    }
  }, [tabla]);

  const handleClickNuevo = () => {
    setAlta(true); //pongo alta en true para q muestre el componente Addcliente
    setTabla(false); //tabla en false para que no se muestre la tabla
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "sisven_id",
        header: "Sisven",
        maxSize: 100,
      },
      {
        accessorKey: "id",
        header: "Cliente",
        maxSize: 100,
      },
      {
        accessorKey: "razon_social",
        header: "Razón Social",
      },
      {
        accessorKey: "direccion_fiscal",
        header: "Dirección Fiscal",
      },
      {
        accessorKey: "cuit",
        header: "Cuit/DNI",
      },
      {
        accessorKey: "sucursal",
        header: "Sucursal",
      },
      {
        accessorKey: "condicion",
        header: "Condicion Pago",
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };

     useEffect(() => {
  logEventos(
    "acceso al menú clientes",
     "Envasado",
      "clientes", 
      localStorage.getItem("user"));
}, []);

  return (
    <div>
      <Navbar />
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
        {tabla && (
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={filteredClientes ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={true} //deshabilita las acciones POR COLUMNA
            enableGlobalFilterModes={true}
            enableHiding={false}
            enableRowActions={true}
            enableColumnFilters={true}
            enableFullScreenToggle={true}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            enableGlobalFilter={false}
            enableSearch={false}
            enableToolbarInternalActions={true}
            // enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            // muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={true}
            displayColumnDefOptions={displayColumnDefOptions}
            state={{ isLoading: loading }} 
            enableColumnResizing={true}
            columnResizeMode="onChange"
            enablePinning
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                backgroundColor:
                  row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                color: "black",
              },
            })}
             muiTableBodyRowProps={({ row }) => ({
               onClick: () => {
                  setDataCliente(row.original);
                  setTabla(false);
                  setFicha(true);
                },
               sx: {
                 cursor: 'pointer',
               },
             })}
            renderTopToolbarCustomActions={(row, table) => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxTwoToneIcon color="asd" />}
                  onClick={handleClickNuevo}
                >
                  Nuevo Cliente
                </Button>
                <Typography variant="poster" fontSize={26}>
                  <PeopleIcon sx={{ fontSize: 20 }} />
                  Clientes de envasados
                </Typography>
              </>
            )}
            muiSearchTextFieldProps={{
        placeholder: "Buscar en todos los campos...",
        size: "small",
        sx: { minWidth: 280 },
        variant: "outlined",
      }}
            renderToolbarInternalActions={({ table }) => (
              <>
                <BuscadorClientes
                  data={clientes || []}
                  onFilter={setFilteredClientes}
                />
                {!hiddenmuestrainactivo ? (
                  <Tooltip title="Muestra Inactivos">
                    <IconButton
                      onClick={() => obtenerclientesInactivos()}
                      color="error"
                    >
                      <PersonOffIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {!hiddenmuestraactivos ? (
                  <Tooltip title="Mostrar ACTIVOS" color="success">
                    <IconButton onClick={() => obtenerclientes()}>
                      <PersonIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
                <MRT_ToggleFiltersButton table={table} />
                <MRT_ShowHideColumnsButton table={table} />
                <MRT_ToggleDensePaddingButton table={table} />
                <MRT_FullScreenToggleButton table={table} />
              </>
            )}
            renderRowActionMenuItems={({ closeMenu, row, index }) => [
              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? null : "none",
                }}
                disabled={row.original.activo === 1}
                onClick={() => {
                  closeMenu();
                  setDataCliente(row.original);
                  setMarcarActivo(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <CheckCircleOutlineIcon color="success" />
                </ListItemIcon>
                Marcar Activo
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataCliente(row.original);
                  setEditar(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <BorderColorIcon color="primary" />
                </ListItemIcon>
                Editar
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataCliente(row.original);
                  setBaja(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <Delete color="error" />
                </ListItemIcon>
                Marcar Inactivo
              </MenuItem>,
              <Divider light />,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataCliente(row.original);
                  setTabla(false);
                  setFicha(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <RemoveRedEyeIcon color="success" />
                </ListItemIcon>
                Ver Datos De Cliente
              </MenuItem>,
            ]}
          />
        )}
        {alta && <TabAltaEnv alta={setAlta} tabla={setTabla} actualiza={setActualiza}/>}
        {baja && (
          <BajaClienteEnv
            open={baja}
            setOpen={setBaja}
            cliente={dataCliente}
            tabla={setTabla}
            actualizar={obtenerclientes}
          />
        )}
        {marcarActivo && (
          <MarcarActivo
            open={marcarActivo}
            setOpen={setMarcarActivo}
            cliente={dataCliente}
            tabla={setTabla}
            actualizar={obtenerclientes}
          />
        )}
        {editar && (
          <EdicionEnvasado
            open={editar}
            setOpen={setEditar}
            cliente={dataCliente}
            actualizar={obtenerclientes}
          />
        )}
        {ficha ? (
          <FichaCliEnv
            ficha={setFicha}
            tabla={setTabla}
            datos={dataCliente}
            actualizar={obtenerclientes}
          />
        ) : null}
      </Container>
    </div>
  );
}

export default ClientesEnvasado;
